import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { CredentialsSection } from '../components/CredentialsSection';
import { SpecialtySection } from '../components/SpecialtySection';
import { PortfolioCarousel } from '../components/PortfolioCarousel';
import { ProcessSection } from '../components/ProcessSection';
import { TestimonialsCarousel } from '../components/TestimonialsCarousel';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
import { LanguageGate } from '../components/LanguageGate';
export function LandingPage() {
  return <div className="min-h-screen bg-brand-black text-brand-white font-sans" data-id="element-198">
      <LanguageGate data-id="element-199">
        <Navigation data-id="element-200" />
        <main data-id="element-201">
          <div id="hero" data-id="element-202">
            <HeroSection data-id="element-203" />
          </div>
          <div id="about" data-id="element-204">
            <AboutSection data-id="element-205" />
          </div>
          <div id="portfolio" data-id="element-206">
            <PortfolioCarousel data-id="element-207" />
          </div>
          <div id="credentials" data-id="element-208">
            <CredentialsSection data-id="element-209" />
          </div>
          <div id="specialty" data-id="element-210">
            <SpecialtySection data-id="element-211" />
          </div>
          <div id="process" data-id="element-212">
            <ProcessSection data-id="element-213" />
          </div>
          <div id="testimonials" data-id="element-214">
            <TestimonialsCarousel data-id="element-215" />
          </div>
          <div id="contact" data-id="element-216">
            <CTASection data-id="element-217" />
          </div>
        </main>
        <Footer data-id="element-218" />
      </LanguageGate>
    </div>;
}